// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"526":"d395e55c","533":"776c89fd","681":"ad4d6f0c","878":"f8586843"}[chunkId] + ".chunk.css";
};